export const TANTRUM = 'tantrum'
export const SOBBING = 'sobbing'
export const STARING = 'staring'
